import { determineSimulationUsage } from '../utils'
import { DeliveryAddressFieldKeys, InputGroupKeys, MeterDetailsFieldKeys, SimulationFieldKeys } from 'store/customer/enums'
import { RootState, store } from 'store'
import { UsageStepFormInputs } from './types'
import { updateAllInputs } from 'store/customer/slice'
import { REGIONS } from '@boltenergy-be/shared'

/**
 * Updates the store inputs for the usage step
 *
 * @param {UsageStepFormInputs} data
 */
export const updateStoreForUsageStep = (data: UsageStepFormInputs) => {
  // Fetch inputs from store
  const { inputs } = (store.getState() as RootState).customer

  // Update the store inputs
  store.dispatch(
    updateAllInputs({
      inputs: {
        ...inputs,
        [InputGroupKeys.SIMULATION]: {
          ...inputs.simulation,
          [SimulationFieldKeys.USAGE]: determineSimulationUsage(data.usageGrade, data),
          [SimulationFieldKeys.HAS_EXCLUSIVE_NIGHT_METER]: !!data.hasExclNight,
          [SimulationFieldKeys.METER_TYPE]: data.meterType,
          ...(data.hasSolarPanels && data.solarPanels && { [SimulationFieldKeys.SOLAR_PANELS]: Number(data.solarPanels ?? 0) })
        },
        [InputGroupKeys.DELIVERY_ADDRESS]: {
          ...inputs[InputGroupKeys.DELIVERY_ADDRESS],
          [DeliveryAddressFieldKeys.NEEDS_GAS]: data.needsGas
        },
        [InputGroupKeys.METER_DETAILS]: {
          ...inputs.meterDetails,
          [MeterDetailsFieldKeys.COUNTER_TYPE]: data.counterType,
          [MeterDetailsFieldKeys.HAS_SOLAR_PANELS]: !!data.hasSolarPanels,
          [MeterDetailsFieldKeys.WALLONIA_SOLAR_PANELS_SINCE_2024]:
            inputs.simulation.region === REGIONS.wallonia ? data.walloniaSolarPanelsSince2024 : undefined
        }
      }
    })
  )
}
